import Bnbsc from './Bnbsc';

export default Bnbsc;
